export const BASE_DATA_URL = 'data';
export const DEFAULT_CHART_WIDTH = 950; // should be the same as .main in _base.scss
export const CASES_LINE_COLOR = '#3073bf';
export const DEATHS_LINE_COLOR = '#b31227';
export const VACCINATION_CHARTS_LEFT_PADDING = 120;
export const VACCINATION_CHARTS_RIGHT_PADDING = 20;
export const VACCINATION_CHARTS_BAR_HEIGHT = 20;
export const HERD_IMMUNITY_PERCENT = 0.8;

